
/* Desktop menu keyboard navigation */
(function () {
  var root = document.documentElement;
  var nav = document.getElementById('siteNav');
  if (!nav) return;

  var reverseTab = false;
  var previousFocus = null;

  function closeItem(item) {
    item.classList.remove('is-open');

    item.querySelectorAll('li.is-open').forEach(function (child) {
      child.classList.remove('is-open');
    });

    item.querySelectorAll('a[aria-expanded="true"]').forEach(function (link) {
      link.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      reverseTab = event.shiftKey;
      root.classList.add('a46-nav-keyboard');
    }
  }, true);

  function pointerNavigation() {
    reverseTab = false;
    root.classList.remove('a46-nav-keyboard');
  }

  document.addEventListener('pointermove', pointerNavigation, {
    passive: true
  });

  document.addEventListener('pointerdown', pointerNavigation, true);

  nav.addEventListener('focusout', function (event) {
    previousFocus = event.target;
  }, true);

  nav.addEventListener('focusin', function (event) {
    var topItem = event.target.closest('#siteNav > li');

    var isTopLink = topItem &&
      event.target === topItem.querySelector(':scope > a');

    var returningFromSubmenu = false;

    if (reverseTab && isTopLink &&
        previousFocus && topItem.contains(previousFocus)) {

      var submenu = topItem.querySelector(
        ':scope > .megamenu, :scope > ul.dropdown'
      );

      returningFromSubmenu =
        submenu && submenu.contains(previousFocus);
    }

    nav.querySelectorAll(':scope > li.is-open').forEach(function (item) {
      if (item !== topItem || returningFromSubmenu) {
        closeItem(item);
      }
    });
  }, true);
})();

/* Audio46: keyboard focus guard for the existing mobile navigation drawer. */
(function () {
  function init() {
    var toggle = document.querySelector('.js-mobile-nav-toggle');
    var drawer = document.querySelector('.mobile-nav-wrapper');
    var close = drawer && drawer.querySelector('.closemobileMenu');
    if (!toggle || !drawer || !close) return;

    var mobile = window.matchMedia('(max-width: 998px)');
    var wasOpen = false;

    drawer.id = drawer.id || 'MobileNavWrapper';
    drawer.setAttribute('aria-label', 'Mobile menu');
    toggle.setAttribute('aria-controls', drawer.id);
    toggle.setAttribute('aria-label', 'Menu');

    function focus(element) {
      if (!element) return;
      try { element.focus({ preventScroll: true }); }
      catch (err) { element.focus(); }
    }

    function isOpen() {
      return mobile.matches && drawer.classList.contains('active');
    }

    function focusable() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), [role="button"][tabindex="0"], [tabindex="0"]'),
        function (element) {
          return element.getClientRects().length > 0 &&
            window.getComputedStyle(element).visibility !== 'hidden';
        }
      );
    }

    function sync() {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        focus(close);
      } else if (mobile.matches) {
        focus(toggle);
      }
    }

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close.click();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusable();
      if (!items.length) {
        event.preventDefault();
        focus(close);
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        focus(event.shiftKey ? last : first);
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        focus(last);
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        focus(first);
      }
    }, true);

    document.addEventListener('focusin', function (event) {
      if (isOpen() && !drawer.contains(event.target)) focus(close);
    }, true);

    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else if (mobile.addListener) mobile.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;

  main.addEventListener('blur', function () {
    main.removeAttribute('tabindex');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var link = event.target.closest('a[href]');
    if (!link || link.hash !== '#MainContent') return;

    if (link.origin !== location.origin ||
        link.pathname !== location.pathname ||
        link.search !== location.search) return;

    main.setAttribute('tabindex', '-1');
    main.focus();
  });
})();

(function () {
  if (!window.jQuery) return;

  function cleanSlides(slider) {
    slider.querySelectorAll('.slick-slide').forEach(function (slide) {
      slide.removeAttribute('tabindex');
    });
  }

  jQuery(document).on(
    'init reInit afterChange setPosition',
    '.product-single__thumbnails',
    function (event) {
      var slider = event.currentTarget;

      requestAnimationFrame(function () {
        cleanSlides(slider);
      });
    }
  );

  document.querySelectorAll('.product-single__thumbnails')
    .forEach(cleanSlides);
})();